const GATEWAY_URL = process.env.GATEWAY_URL || "";
const TOKEN_STORAGE_KEY = "hermes_jwt";
export class GatewayApiClient {
    constructor() {
        this.token = null;
        this.token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
    }
    setToken(token) {
        this.token = token;
        sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
    }
    clearToken() {
        this.token = null;
        sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    }
    getToken() {
        return this.token;
    }
    isAuthenticated() {
        return this.token !== null;
    }
    get baseUrl() {
        return GATEWAY_URL;
    }
    async request(path, options = {}) {
        const headers = {
            "Content-Type": "application/json",
            ...(options.headers || {})
        };
        if (this.token) {
            headers["Authorization"] = `Bearer ${this.token}`;
        }
        const response = await fetch(`${this.baseUrl}${path}`, {
            ...options,
            headers
        });
        if (response.status === 401) {
            this.clearToken();
            throw new Error("UNAUTHORIZED");
        }
        if (!response.ok) {
            const body = await response.text();
            let message = `Request failed: ${response.status}`;
            try {
                const parsed = JSON.parse(body);
                if (parsed.error) {
                    message = parsed.error;
                }
            }
            catch {
                // ignore parse failure
            }
            throw new Error(message);
        }
        const contentType = response.headers.get("content-type") || "";
        if (contentType.includes("application/json")) {
            return response.json();
        }
        return {};
    }
    initiateLogin() {
        const redirectUri = encodeURIComponent(window.location.origin);
        window.location.href = `${this.baseUrl}/login?redirect_uri=${redirectUri}`;
    }
    async refresh() {
        const response = await this.request("/refresh", { method: "GET" });
        if (response.token) {
            this.setToken(response.token);
        }
        return response;
    }
    async getMe() {
        return this.request("/me");
    }
    async getApiKeyStatus() {
        return this.request("/setup/api-key/status");
    }
    async generateApiKey() {
        return this.request("/setup/api-key", { method: "POST" });
    }
    async revokeApiKey() {
        await this.request("/setup/api-key", { method: "DELETE" });
    }
    async unlinkSlack() {
        await this.request("/setup/slack", { method: "DELETE" });
    }
    async getModels() {
        return this.request("/v1/models");
    }
    async getAdminUsage() {
        return this.request("/admin/usage");
    }
    async checkHealth() {
        const response = await fetch(`${this.baseUrl}/health`);
        return response.json();
    }
}
const gatewayApi = new GatewayApiClient();
export default gatewayApi;
